import React from 'react'
import { cn } from '@/lib/utils'

interface ButtonGroupProps extends React.HTMLAttributes<HTMLDivElement> {
  size?: string
  vertical?: boolean
}

export const ButtonGroup: React.FC<ButtonGroupProps> = ({ vertical, className, ...props }) => (
  <div
    className={cn(
      'inline-flex',
      vertical ? 'flex-col' : 'flex-row',
      '[&>button]:rounded-none [&>button:first-child]:rounded-l-md [&>button:last-child]:rounded-r-md',
      className,
    )}
    {...props}
  />
)
